var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.v)?_c('span',[_c('i',{staticClass:"fa-lg",class:_vm.trueClass})]):_c('span',[_c('i',{staticClass:"fa-lg",class:_vm.falseClass})])}
var staticRenderFns = []

export { render, staticRenderFns }